import { render, staticRenderFns } from "./StageButton.vue?vue&type=template&id=0bd043b0&scoped=true&"
import script from "./StageButton.vue?vue&type=script&lang=js&"
export * from "./StageButton.vue?vue&type=script&lang=js&"
import style0 from "./StageButton.vue?vue&type=style&index=0&id=0bd043b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd043b0",
  null
  
)

export default component.exports